var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.debug === 'true' || _vm.debug === true)?_c('span',[_vm._v(_vm._s(_vm.version))]):_vm._e(),(
      _vm.data.item.motivoRechazo != null ||
        _vm.data.item.motivoRechazo != ''
    )?_c('div',[_c('b-button',{attrs:{"variant":"outline-info"},on:{"click":function($event){return _vm.showModal(_vm.data.item)}}},[_vm._v("Ver Motivo")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }